import { DialogTag } from '@pixelgenau/ngx-dialog';

export const FilterTag = new DialogTag<unknown, { filter: boolean }>(
    'filter-dialog',
    () => import('./filter.component'),
);
